import type { SailPlotExtensions } from "@heiselanalytics/sailplot";
import {
  CompactSalesPromotion,
  EmptySelectionSalesPromotion,
} from "../components/SailPlotSalesPromotion";
import { CustomizePage } from "../pages/CustomizePage";
import { PurchaseSuccessPage } from "../pages/PurchaseSuccessPage";
import { ImprovementPage } from "../pages/ImprovementPage";
import { createPlatformPageExtensions } from "./platformPages";

const publicPageExtensions = createPlatformPageExtensions({
  hostingProvider: "cloudflare-pages",
  instructions: true,
  openSource: true,
  paddlePayments: true,
  improvementRequests: true,
});

export const sailplotSalesExtensions: SailPlotExtensions = {
  ...publicPageExtensions,
  emptySelectionContent: EmptySelectionSalesPromotion,
  compactBrandingContent: CompactSalesPromotion,
  routes: [
    ...(publicPageExtensions.routes ?? []),
    {
      path: "/customize",
      title: "Licenses & Branding",
      footer: false,
      component: CustomizePage,
    },
    {
      path: "/order-success",
      title: "Order confirmed",
      component: PurchaseSuccessPage,
    },
    {
      path: "/improvement",
      title: "Suggest an improvement",
      component: ImprovementPage,
    },
  ],
  navigationItems: [
    { id: "customize", label: "Licenses & Branding", path: "/customize" },
    {
      id: "improvement",
      label: "Suggest an Improvement",
      path: "/improvement",
    },
    ...(publicPageExtensions.navigationItems ?? []),
  ],
};
